import { Plus, ChevronDown, Calendar1, UsersRound, CircleDashed, BadgeAlert, Download } from 'lucide-react'
import { BillingPackage } from '../../Packages/types/BillingPackage';

interface UsersHeaderProps {
    usersCount: number,
    activeTab: string;
    setActiveTab: (tab: string) => void;
    selectedService: string;
    setSelectedService: (service: string) => void;
    packages: BillingPackage[];
    selectedPackage: string;
    setSelectedPackage: (packageName: string) => void;
    onExport: () => void;
    searchTerm: string;
    setSearchTerm: (term: string) => void;
}


export default function UsersHeader({ usersCount, activeTab, setActiveTab, setSelectedService, packages, selectedPackage, setSelectedPackage, onExport, searchTerm, setSearchTerm }: UsersHeaderProps) {
    const handleTabClick = (tab: string) => {
        setActiveTab(tab);
    };
    return (
        <div className="w-full flex flex-col items-start justify-start">
            <div className='w-full flex items-center justify-between'>
                <div className="flex items-center gap-x-6">
                    <nav className="flex text-white text-xs">
                        <ul className="flex gap-x-6">
                            <li
                                className={`cursor-pointer ${activeTab === 'All' ? 'font-bold text-white' : 'text-gray-500'}`}
                                onClick={() => handleTabClick('All')}
                            >
                                All
                            </li>
                            <li
                                className={`cursor-pointer ${activeTab === 'Active' ? 'font-bold text-white' : 'text-gray-500'}`}
                                onClick={() => handleTabClick('Active')}
                            >
                                Active
                            </li>
                            <li
                                className={`cursor-pointer ${activeTab === 'Suspended' ? 'font-bold text-white' : 'text-gray-500'}`}
                                onClick={() => handleTabClick('Suspended')}
                            >
                                Suspended
                            </li>
                            <li
                                className={`cursor-pointer ${activeTab === 'Blocked' ? 'font-bold text-white' : 'text-gray-500'}`}
                                onClick={() => handleTabClick('Blocked')}
                            >
                                Blocked
                            </li>
                        </ul>
                    </nav>
                </div>

                <button className='w-fit flex items-center justify-center gap-x-1 bg-card rounded-md px-3 py-2 text-white text-xs hover:scale-105 transition-all cursor-pointer'>
                    <Download size={14} />
                    <p>Download CSV</p>
                </button>
            </div>

            <div className='w-full flex items-center justify-start my-3 gap-x-4'>
                <div className='w-[230px] flex items-center justify-start gap-x-1 bg-none rounded-md px-2 py-3 text-sm border border-gray-400 hover:scale-105 transition-all cursor-pointer'>
                    <UsersRound className='text-white mx-2' size={24} />
                    <div className='flex flex-col items-start justify-center text-white px-3'>
                        <p>Total Registered Users</p>
                        <p>{usersCount}</p>
                    </div>
                </div>

                <div className='w-[230px] flex items-center justify-start gap-x-1 bg-none rounded-md px-2 py-3 text-sm border border-gray-400 hover:scale-105 transition-all cursor-pointer'>
                    <CircleDashed className='text-green-500 mx-2' size={24} />
                    <div className='flex flex-col items-start justify-center text-white px-3'>
                        <p>Active</p>
                        <p>{usersCount}</p>
                    </div>
                </div>

                <div className='w-[230px] flex items-center justify-start gap-x-1 bg-none rounded-md px-2 py-3 text-sm border border-gray-400 hover:scale-105 transition-all cursor-pointer'>
                    <BadgeAlert className='text-red-500 mx-2' size={24} />
                    <div className='flex flex-col items-start justify-center text-white px-3'>
                        <p>Issues</p>
                        <p>0</p>
                    </div>
                </div>
            </div>

            <div className='w-full flex items-center justify-between'>
                <div className="flex items-center gap-x-4 my-3">
                    <div className="relative">
                        <select className="w-40 h-8 px-3 py-1 rounded-md border border-gray-400 bg-white text-xs text-gray-700"
                            onChange={(e) => setSelectedService(e.target.value)}>
                            <option value="All">All Services</option>
                            <option value="kanema online">Kanema Online</option>
                            <option value="mingoli">Mingoli</option>
                            <option value="katswiri">Katswiri</option>
                            <option value="nkhani">Nkhani</option>
                        </select>
                    </div>

                    <div className="relative">
                        <select className="w-40 h-8 px-3 py-1 rounded-md border border-gray-400 bg-white text-xs text-gray-700">
                            <option value="">Age</option>
                            <option value="">18+</option>
                            <option value="">21+</option>
                            <option value="">25+</option>
                            <option value="">30+</option>
                        </select>
                    </div>

                    <div className="relative">
                        <select className="w-40 h-8 px-3 py-1 rounded-md border border-gray-400 bg-white text-xs text-gray-700">
                            <option value="">Registration Type</option>
                            <option value="">Google Sign In</option>
                            <option value="">Apple Sign In</option>
                            <option value="">Phone Number</option>
                            <option value="">Email</option>
                        </select>
                    </div>

                    <div className="relative">
                        <select className="w-40 h-8 px-3 py-1 rounded-md border border-gray-400 bg-white text-xs text-gray-700">
                            <option value="">Status</option>
                            <option value="">Active</option>
                            <option value="">Suspended</option>
                            <option value="">Blocked</option>
                        </select>
                    </div>

                    <button className='w-fit flex items-center justify-center gap-x-1 bg-white rounded-md px-2 py-2 text-gray-700 text-xs'>
                        <p>Registration Date</p>
                        <Calendar1 size={14} />
                    </button>
                </div>

                <input type="text" placeholder="Search User" className="w-72 h-8 px-3 py-1 rounded-md border border-white bg-transparent text-xs text-white" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />

            </div>

        </div>
    )
}